import { useEffect, useRef } from "react";

const InfiniteScroll = ({ loadMore, hasMore, children, threshold = 1.0 }) => {
  const loaderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore) {
          loadMore();
        }
      },
      { threshold }
    );

    const currentLoaderRef = loaderRef.current;

    if (currentLoaderRef) {
      observer.observe(currentLoaderRef);
    }

    return () => {
      if (currentLoaderRef) {
        observer.unobserve(currentLoaderRef);
      }
    };
  }, [loadMore, hasMore, threshold]);

  return (
    <div>
      {children}
      {hasMore && <div ref={loaderRef}>Loading more...</div>}
    </div>
  );
};
export default InfiniteScroll;
